import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, ShieldCheckIcon, LockIcon, ZapIcon, CreditCardIcon } from 'lucide-react';
import { CTAButton, CHECKOUT_URL } from './CTAButton';
import { MoreTestimonials } from './MoreTestimonials';
const plan = {
  name: '📘 NEURO-RUNNING PACK™',
  ideal: 'Corredores que quieren dominar su mente para dominar el asfalto',
  was: '$30',
  now: '$15',
  features: ['12 Tomos completos', 'Protocolo para atravesar el muro', 'Sistema anti-autosabotaje', 'Control de ansiedad pre-carrera', '5 Bonos estratégicos gratis', 'Garantía 7 días'],
  cta: '🔥 Quiero el Neuro-Pack + 5 Bonos'
};
const trust = [{
  icon: LockIcon,
  label: 'Pago 100% seguro'
}, {
  icon: ZapIcon,
  label: 'Acceso inmediato'
}, {
  icon: CreditCardIcon,
  label: 'Crédito / Débito'
}];
export function Pricing() {
  return <section id="pricing" aria-label="Precios" className="bg-radial-glow w-full overflow-x-hidden" data-id="element-130" data-mp="3c8a6rubrimv1">
      <div className="mx-auto w-full max-w-5xl px-5 py-12" data-id="element-131" data-mp="3vzgrvnxml0wr">
        <h2 className="text-center font-display text-2xl font-bold text-white sm:text-3xl" data-id="element-132" data-mp="3vyx801of02g3">
          💰 Activá tu acceso ahora
        </h2>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-40px'
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative mx-auto mt-10 flex w-full max-w-md flex-col items-center rounded-3xl border border-azul/40 bg-ink-2 px-6 pb-7 pt-10 text-center shadow-[0_20px_60px_-20px_rgba(31,155,255,0.45)]" data-id="element-133" data-mp="9si7tvwt2d03">
          <h3 className="font-display text-lg font-bold text-white" data-id="element-134" data-mp="3n6d8z047nvuq">{plan.name}</h3>
          <p className="mt-2 text-sm text-white/60" data-id="element-135" data-mp="3rywvwnosg3c7">
            <span className="font-semibold text-white/80" data-id="element-136" data-mp="3rzojpcc58wrx">Ideal para:</span> {plan.ideal}
          </p>

          <div className="mt-6" data-id="element-137" data-mp="2zhkj9le6mk8k">
            <span className="text-base font-medium text-white/40 line-through" data-id="element-138" data-mp="2zgr88886x8km">{plan.was}</span>
            <div className="text-plata-shine font-display text-4xl font-bold" data-id="element-139" data-mp="2rg35g6jtu4p1">{plan.now} USD</div>
            <p className="mt-1 text-xs font-semibold text-naranja-soft" data-id="element-140" data-mp="2mijrz8uydvy5">
              Pago único · Acceso de por vida
            </p>
          </div>

          <ul className="mt-6 w-full flex-1 space-y-3 text-left" data-id="element-141" data-mp="318qycq7oroih">
            {plan.features.map(f => <li key={f} className="flex items-start gap-2.5 text-sm text-white/80" data-id="element-142" data-mp="2w9xln00841jd">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-azul-soft" strokeWidth={3} data-id="element-143" data-mp="28k396jjtgezn" />
                {f}
              </li>)}
          </ul>

          <div className="mt-7 flex w-full justify-center" data-id="element-144" data-mp="2ih7wimpeegi1">
            <CTAButton size="md" href={CHECKOUT_URL} data-id="element-145" data-mp="2dh3gexsejnsc">
              {plan.cta}
            </CTAButton>
          </div>

          <div className="mt-5 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs font-medium text-white/50" data-id="element-146" data-mp="3tutvezl27wgr">
            {trust.map(({
            icon: Icon,
            label
          }) => <span key={label} className="inline-flex items-center gap-1.5 whitespace-nowrap" data-id="element-147" data-mp="adnax2mu5m6">
                <Icon className="h-4 w-4 text-plata" data-id="element-148" data-mp="59grkfasg7t3" />
                {label}
              </span>)}
          </div>
        </motion.div>

        <MoreTestimonials data-id="element-149" data-mp="3ngejxkzi0o0r" />

        <div className="mx-auto mt-12 flex w-full max-w-2xl items-start gap-3 rounded-2xl border border-plata/25 bg-white/[0.04] p-5 text-left" data-id="element-150" data-mp="3nh68wcylbni2">
          <ShieldCheckIcon className="mt-0.5 h-6 w-6 shrink-0 text-plata" data-id="element-151" data-mp="j0lhgpoctlq8" />
          <p className="text-[15px] leading-relaxed text-plata" data-id="element-152" data-mp="nzop8hvpy61w">
            <span className="font-display font-bold text-white" data-id="element-153" data-mp="nz6i2q7iq7f7">
              Garantía de devolución de 7 días.
            </span>{' '}
            Si abrís los tomos y en la primera semana sentís que no vale lo que pagaste, pedís el
            reembolso y te devolvemos el 100%. Sin formularios, sin drama, sin vueltas. Creemos
            tanto en este sistema que asumimos todo el riesgo nosotros.
          </p>
        </div>
      </div>
    </section>;
}